export default {"src":"/_next/static/media/zenit_rendelo-2.7fd023b5.JPG","height":4284,"width":5712,"blurWidth":0,"blurHeight":0};